import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import {SystemService} from 'app/services/system.service';
import {Usuario} from 'app/interfaces/interfaces';
import { Router } from '@angular/router';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseNavigation } from '@fuse/types';
import {Entity} from '../product/product.model';
import {RoleService} from '../../components/role-form/role.service';
import {AuthService} from '../../services/auth/auth.service';
import {NotificationService} from 'app/util/errors/notification.service';

@Component({
    selector     : 'login',
    templateUrl  : './login.component.html',
    styleUrls    : ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class LoginComponent implements OnInit
{
    private navigation: FuseNavigation[];

    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private _systemService: SystemService,
        private _roleService: RoleService,
        private _authService: AuthService,
        private _router: Router,
        private _fuseNavigationService: FuseNavigationService,
        private _notificationService: NotificationService
    )
    {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: true
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }
    loginForm: FormGroup;


    initNavegation(): FuseNavigation[] {
        const children = [];
        const visibility = this._systemService.visibility;
        const result: FuseNavigation[] =  [
            {
                id: 'applications',
                title: 'Personal',
                // translate: 'NAV.APPLICATIONS',
                type: 'group',
                children: []
            },

        ];

        children.push(
            {
                id: 'project',
                title: 'Proyectos',
                translate: 'PROJECT.LABEL_P',
                type: 'item',
                icon: 'business',
                url: '/proyecto/todos',
            });
        if (!visibility.calibrationModuleOn) {
            children.push(
                {
                    id: 'sample',
                    title: 'Mis Horas',
                    // translate: 'NAV.SAMPLE.TITLE',
                    type: 'item',
                    icon: 'timer',
                    url: '/mishoras'
                });
        }
        else {
            children.push(
                {
                    id: 'quotes',
                    title: 'Cotizaciones',
                    // translate: 'NAV.SAMPLE.TITLE',
                    type: 'item',
                    icon: 'attach_money',
                    url: '/quotes'
                });
            children.push(
                {
                    id: 'calibrations',
                    title: 'Calibraciones',
                    // translate: 'NAV.SAMPLE.TITLE',
                    type: 'item',
                    icon: 'timer',
                    url: '/calibrations'
                });
        }

        result[0].children = children;
        return result;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.loginForm = this._formBuilder.group({
            user   : ['', Validators.required],
            password: ['', Validators.required]
        });
    }

    updateNavegation(): void{
        const usuario: Usuario = this._systemService.usuario;
        const adminChildren: any[] = [];
        const managementChildren: any[] = [];
        this.navigation = this.initNavegation();

        if (!this._systemService.visibility.calibrationModuleOn && this._systemService.canAction('viewHHSummary')) {
            managementChildren.push(
                {
                    id       : 'horas',
                    title    : 'Horas registradas',
                    type     : 'item',
                    icon     : 'timers',
                    url      : '/hours'
                }
                // {
                //     id       : 'statistics',
                //     title    : 'Estadísticas',
                //     type     : 'item',
                //     icon     : 'insert_chart',
                //     url      : '/hours'
                // }
            );
        }

        if (this._systemService.canAction('adminUsers') || this._systemService.canAction('viewUsers')) {
            adminChildren.push({
                id       : 'usuarios',
                title    : 'Usuarios',
                type     : 'item',
                icon     : 'person',
                url      : '/administration/user'
            });
        }
        if (this._systemService.canAction('adminRoles') || this._systemService.canAction('viewRoles')) {
            adminChildren.push({
                id       : 'roles',
                title    : 'Roles',
                type     : 'item',
                icon     : 'account_box',
                url      : '/administration/role',
            });
        }
        if (this._systemService.canAction('adminTeams') || this._systemService.canAction('viewTeams')) {
            adminChildren.push({
                id       : 'teams',
                title    : 'Grupo',
                type     : 'item',
                icon     : 'group',
                url      : '/administration/team',
            });
        }
        if (this._systemService.canAction('adminClients') || this._systemService.canAction('viewClients')) {
            adminChildren.push({
                id       : 'clients',
                title    : 'Clientes',
                type     : 'item',
                icon     : 'store',
                url      : '/administration/client',
            });
        }
        if (this._systemService.visibility.calibrationModuleOn && (this._systemService.canAction('adminClients') || this._systemService.canAction('viewClients'))) {
            adminChildren.push({
                id       : 'instrumentsType',
                title    : 'Tipo de instrumentos',
                type     : 'item',
                icon     : 'build',
                url      : '/administration/instrumentType',
            });

            adminChildren.push({
                id       : 'instrumentModel',
                title    : 'Modelo de Instrumento',
                type     : 'item',
                icon     : 'branding_watermark',
                url      : '/administration/instrumentModel',
            });

            adminChildren.push({
                id       : 'icc',
                title    : 'Plantillas ICC',
                type     : 'item',
                icon     : 'ICC',
                url      : '/administration/icc',
            });
        }

        if (this._systemService.canAction('useExternalApi') || this._systemService.canAction('adminUsers')) {
            adminChildren.push({
                id       : 'apiKeys',
                title    : 'API Keys / Integraciones',
                type     : 'item',
                icon     : 'vpn_key',
                url      : '/administration/apiKeys',
            });
        }

        const nav: FuseNavigation = {
            id       : 'administration',
            title    : 'Administracion',
            type     : 'group',
            children : adminChildren
        };

        const manageNav: FuseNavigation = {
            id       : 'management',
            title    : 'Gerencial',
            type     : 'group',
            children : managementChildren
        };

        if (managementChildren.length > 0) {
            this.navigation.push(manageNav);
        }

        if (adminChildren.length > 0) {
            this.navigation.push(nav);
        }



        this._fuseNavigationService.unregister('m');
        this._fuseNavigationService.register('m', this.navigation);

        // Set the main navigation as our current navigation
        this._fuseNavigationService.setCurrentNavigation('m');


    }

    onSubmit(): void{
        const credentials = {
            login: this.loginForm.value.user,
            password: this.loginForm.value.password
        };

        this._authService.signIn(credentials).subscribe({
            next: (response) => {
                // El AuthService ya maneja el almacenamiento del token y usuario
                this._systemService.loadUserConfiguration(response.user);
                this.updateNavegation();
                this._router.navigateByUrl('proyecto/todos');

                // Cargar datos necesarios del sistema
                this.loadSystemData();
            },
            error: (error) => {
                console.error('Error en login:', error);
                let theMessage = 'Usuario o clave incorrectos';
                if (error.error && typeof error.error === 'string' && error.error.includes('##')) {
                    const message: string[] = error.error.split('##');
                    const lastPart = message[message.length - 1];
                    if (lastPart.includes(':')) {
                        const parts = lastPart.split(':');
                        theMessage = parts[parts.length - 1].trim();
                    } else {
                        theMessage = lastPart;
                    }
                }
                this._notificationService.notify(theMessage);
            }
        });
    }

    private loadSystemData(): void {
        this._systemService.getClients().subscribe(
            resp => this._systemService.clients = resp
        );
        this._systemService.getTeams().subscribe(
            resp => this._systemService.teams = resp
        );
        this._systemService.getUsers().subscribe(
            resp => {
                this._systemService.allUsers = resp;
                const users: Entity[] = [];
                for (const item of resp) {
                    if (item.enabled) {
                        users.push(new Entity(item));
                    }
                }
                this._systemService.users = users;
            }
        );
        this._systemService.getRoles().subscribe(
            resp => this._systemService.roles = resp
        );
        this._roleService.getAllPermissions().subscribe(
            resp => this._systemService.allPermissions = resp
        );
    }
}
